<template>
  <div style="height: 100%">
    <SplitContainer3 style="height:100%" :layout="12" :split_setting1="0.48">
      <template #main>
        <TableMain name="one table" ref="QTHITable1" :fields="fields" :title="table_title.title1"
          :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
          :show_date_picker="false" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
          :query_button_label="query_lable" :isBusy="isBusy" :hb_table_class="'hb_table_qthtranstable_class1'"
          :only_text="$t('common.show_all')" @only_methods="only_main_methods" @on_query="on_query"
          :table_height_adjust="-6" :show_toolbar_button="[0, 0, 0, 0, 1]" @tool_invoke="tool_invoke"
          @current_changed="current_changed" tableref="bef5c334f4c24309a942f0aa92a4a8e9">
          <template #query>
            <el-date-picker class="ml-1" size="small" style="width: 220px" v-model="date_range" type="daterange"
              align="right" unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
              :picker-options="pickerOptions()">
            </el-date-picker>
            <el-input class="ml-1" placeholder="报价申请编号" clearable size="small" style="width: 180px"
              v-model="QuotationTaskNum"></el-input>
            <el-input placeholder="客户名称" class="ml-1" clearable size="small" style="width: 180px"
              v-model="CustName"></el-input>
          </template>
        </TableMain>
      </template>
      <template #top>
        <TableMain ref="QTHITable2" :fields="detail_fields" :show_query_container="false" :title="table_title.title2"
          :date_picker_label="date_picker_label" :table_height_adjust="10" :show_pagination="true" :show_filter="false"
          :show_toolbar="false" :pager_count="5" :isBusy="isBusy2" :loading_width="45"
          @current_changed="current_changed_detail" tableref="7875602b011f47329e09804c7a08144a">
        </TableMain>
      </template>
      <template #bottom>
        <TableMain ref="QTHITable3" :fields="detail_transport_fields" :show_query_container="false"
          :title="table_title.title3" :show_toolbar="false" :date_picker_label="date_picker_label"
          :table_height_adjust="2" :show_pagination="true" :show_filter="false" :pager_count="5" :isBusy="isBusy3"
          :show_toolbar_button="[0, 0, 0, 0, 0]" tableref="edb68f812be245f484e15c5bf951f746">
          <template #toolbar>
            <el-popover placement="right" title="提示" width="200" trigger="hover" content="请先点选报价申请明细(不是勾选)。"
              style="border-color: red;">
              <i slot="reference" class="el-icon-question ml-2" style="font-size:18px;margin-top: 6px;"></i>
            </el-popover>
          </template>
          <template #operation>
            <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="Detail_SaveData"
              :label="$t('common.save')" class="ml-2"></QueryButton>
            <QueryButton :type="'primary'" :iconClass="'iconfont icon-upload'" :size="'mini'" @on_query="Detail_Submit"
              :label="$t('common.commit')" class="ml-2"></QueryButton>
          </template>
        </TableMain>
      </template>
    </SplitContainer3>

  </div>
</template>

<script>
import * as QuotationTaskController from "../../controllers/sd/QuotationTaskController"
import * as QuotationTaskHandleController from "../../controllers/sd/QuotationTaskHandleController"
import QueryButton from "../components/base/QueryButton"
import SplitContainer3 from "../components/container/SplitContainer3"
import TableMain from "../components/table/TableMain"

export default {
  components: {
    SplitContainer3,
    TableMain,
    QueryButton
  },
  data() {
    return {
      date_picker_label: "",
      date_range: [this.$date.addMonths(new Date(), -3), new Date()],
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "quote_apply",
        title2: "quote_apply_detail",
        title3: "quote_apply_handle_other_cost"
      },
      fields: _.cloneDeep(QuotationTaskController.fields.default),
      detail_fields: QuotationTaskHandleController.fields.detail_transport_cost,
      detail_transport_fields: _.cloneDeep(QuotationTaskHandleController.fields.detail_transport_handle),
      qt_modal_title: "",
      QuotationTaskNum: "",//报价申请编号
      CustName: "",//客户名称
      isBusy: false,
      isBusy2: false,
      isBusy3: false,
      isAll: false
    }
  },
  created() {
    this.fields = _.filter(this.fields, (t) => {
      return t.key != "fcCheckSQOApproved" && t.key != "SQOApprover" && t.key != "is_send_email" && t.key != "quotationType" && t.key !== "fcCheckSQOHasClosed"
    })
    let _field = _.find(this.fields, {
      key: "id",
    })
    delete _field["type"]
  },
  mounted() {

  },
  methods: {
    pickerOptions() {
      return {
        shortcuts: [
          {
            text: "最近7天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近90天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit("pick", [start, end])
            },
          },
        ],
      }
    },
    //#region 报价申请相关操作
    async on_query(set_data) {
      this.isBusy = true
      set_data([])
      let hasDate = true
      let p = { is_deleted: { "=": 0 } }
      if (this.QuotationTaskNum != "") {
        p.QuotationTaskNum = { like: "%" + this.QuotationTaskNum + "%" }
        hasDate = false
      }
      if (this.CustName != "") {
        p.CustName = { like: "%" + this.CustName + "%" }
        hasDate = false
      }
      if (!_.isNull(this.date_range) && hasDate) {
        let _toDate = this.$date.format(this.date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        p["create_at"] = { ">=": this.$date.format(this.date_range[0], "yyyy-MM-dd"), "<": _toDate }
      }
      let _result = await QuotationTaskController.methods.getData(p, "transport")
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.filter(_result[0], (t) => {
          if (t.fcCheckSQOApproved && !t.fcCheckSQOIsAllClosed && !t.fcCheckQuoteDetailIsAllOutsourcing) return t
        })
        _.each(dt, (t) => {
          t._error = !t.fcCheckQuoteConfirmIsOk
        })
        if (!this.isAll)
          dt = _.filter(dt, { fcCheckQuoteConfirmIsOk: false })
        set_data(_.orderBy(dt, ["id"], ["desc"]))
      }
      this.isBusy = false
    },

    ///打印导出
    tool_invoke(data, cb) {
      if (data.tool == "adhoc_report") {
        let _data = {
          state: true,
          fields: this.fields,
          title: this.$t("table.table_customer"),
          sheet_title: "部件档案",
        }
        ///调用公用导出(如果调用特定导出则可以写在这里)
        cb(_data)
      } else {
        ///调用公用打印(如果调用特定打印则可以写在这里)
        cb(_data)
      }
    },

    async current_changed(old, current) {
      this.$refs.QTHITable2.SetData([])
      if (current) {
        await this.Detail_Query(current.id)
      }
    },
    //#endregion

    //#region 报价明细相关
    ///查询报价明细
    async Detail_Query(QTId) {
      this.isBusy2 = true
      let p = { is_deleted: { "=": 0 } }
      p.QuotationTaskId = { "=": QTId }
      p.IsHomemade = { "<>": 2 }
      let _result = await QuotationTaskController.methods.getDetailData(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.map(_result[0], (t) => {
          t.IsHomemade = t.IsHomemade ? 1 : 0
          t.Manufacturer = t.Manufacturer.split(",")
          return t
        })
        this.$refs.QTHITable2.SetData(_.orderBy(dt, ["LineNum"], ["asc"]))
      }
      this.isBusy2 = false
    },

    ///明细行点击事件
    current_changed_detail(old, current) {
      this.$refs.QTHITable3.SetData([])
      if (current && current.ItemId == "") {
        this.msgToasts("请完善物料档案！", "info")
        return
      }
      if (current && current.Manufacturer) {

        let dt = []
        if (current.TransportCost == "" || current.TransportCost == null) {
          for (var i in current.Manufacturer) {
            let dm = _.find(this.$store.state.biz_data.baseData.CompanyInfo, { DataArea: current.Manufacturer[i] })
            if (dm && dm.VenderAccountNum) {
              let m = {
                id: current.id,
                dataAreaId: current.Manufacturer[i],
                AccountNum: dm.VenderAccountNum,
                AccountName: dm.CompanyName
              }
              let costItems = this.$store.state.biz_data.baseData.CostItems
              for (var j in costItems) {
                m.CostName = costItems[j].CostName
                dt.push(_.cloneDeep(m))
              }
            }
          }
        }
        else {
          let costItems = _.cloneDeep(this.$store.state.biz_data.baseData.CostItems)
          let bomId_dt = JSON.parse(current.TransportCost)
          dt = _.map(bomId_dt, (t) => {
            let m = _.cloneDeep(t)
            m.id = current.id
            _.remove(costItems, (d) => {
              return m.CostName == d.CostName
            })
            return m
          })
          let group_dt = _.groupBy(dt, "dataAreaId")
          for (var b in group_dt) {
            for (var k in costItems) {
              let m = _.cloneDeep(group_dt[b][0])
              m.CostName = costItems[k].CostName
              m.TransportCost = null
              dt.push(_.cloneDeep(m))
            }
          }
        }
        this.$refs.QTHITable3.SetData(dt)
      }
    },

    ///保存明细
    async Detail_SaveData(cb) {
      //数据验证
      let msg = "", lm = {}, p = { add: [], edit: [] }
      let detail_data = _.filter(this.$refs.QTHITable3.my_data, (t) => {
        if (!t.TransportCost) t.TransportCost = 0
        return t
      })
      // if (detail_data.length == 0) {
      //   this.msgToasts(this.$t("notify.not_data"), "info");
      //   cb(null);
      //   return;
      // }

      // let require_fileds = _.map(_.filter(this.detail_transport_fields, { required: true }), (t) => { return t });
      _.each(detail_data, (t) => {
        let m = _.cloneDeep(t)
        for (var k in m) {
          if (_.startsWith(k, "_")) delete m[k]
        }
        // for (var i in require_fileds) {
        //   let fm = require_fileds[i];
        //   if (msg == "" && (m[fm.key] == "" || !m[fm.key])) {
        //     msg = fm.label + "不能为空！"
        //   }
        // }
        lm["id"] = m.id
      })
      if (msg != "") {
        this.msgToasts(msg, "info")
        cb(null)
        return
      }

      lm["TransportCost"] = JSON.stringify(_.map(detail_data, (t) => {
        return {
          AccountNum: t.AccountNum,
          AccountName: t.AccountName,
          TransportCost: t.TransportCost,
          CostName: t.CostName,
          dataAreaId: t.dataAreaId
        }
      }))

      p.edit.push(lm)
      let rt = await QuotationTaskController.methods.saveDetailData(p)
      if (rt) {
        let lineCurrent = this.$refs.QTHITable2.GetCurrentItem()
        lineCurrent.TransportCost = lm.TransportCost
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true, true)
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    async Detail_Submit(cb) {
      //数据验证
      let lm = {}, p = { add: [], edit: [] }
      let detail_data = _.filter(this.$refs.QTHITable3.my_data, (t) => {
        if (!t.TransportCost) t.TransportCost = 0
        return t
      })
      // if (detail_data.length == 0) {
      //   this.msgToasts(this.$t("notify.not_data"), "info");
      //   cb(null);
      //   return;
      // }

      _.each(detail_data, (t) => {
        lm["id"] = t.id
      })

      lm["TransportCost"] = JSON.stringify(_.map(detail_data, (t) => {
        return {
          AccountNum: t.AccountNum,
          AccountName: t.AccountName,
          TransportCost: t.TransportCost,
          CostName: t.CostName,
          dataAreaId: t.dataAreaId
        }
      }))
      lm["TransportConfirmState"] = true
      p.edit.push(lm)
      let rt = await QuotationTaskController.methods.saveDetailData(p)
      if (rt) {
        let lineCurrent = this.$refs.QTHITable2.GetCurrentItem()
        lineCurrent.TransportCost = lm.TransportCost
        lineCurrent.TransportConfirmState = true
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true, true)
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    only_main_methods(only_value) {
      this.isAll = only_value
      this.on_query(this.$refs.QTHITable1.SetData)
    }
    //#endregion
  },
}
</script>
<style>
.hb_table_qthtranstable_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 100rem;
}
</style>
